<template>
    <div :style="wrapStyle">
        <component
            :is="component"
            v-model:value="modelVal"
            :kee="kee"
            :split="split"
            :minTitle="calcMinTitle"
            :maxTitle="calcMaxTitle"
            :theme="theme"
            :label="label"
            :inMore="inMore"
            :data="data"
        />
    </div>
</template>

<script>
import InputBox from '../input-box/index.vue';
import CalendarSelect from '../calendar-select/index.vue';
import { mapState } from 'pinia';
import { usePageStore } from '@/store';
import { defaultLngCode } from '@/globalization/constant.js';
export default {
    name: 'Range',
    emits: ['change', 'update:value'],
    props: {
        theme: {
            type: String,
            default: ''
        },
        label: {
            type: String,
            default: ''
        },
        kee: {
            type: String,
            default: ''
        },
        inMore: {
            type: Boolean,
            default: false
        },
        value: {
            type: String,
            default: ''
        },
        data: {
            type: Object,
            default: () => ({})
        },
        wrapStyle: {
            type: Object,
            default: () => ({ width: '100%' })
        },
    },
    data: function() {
        return {
            split: ',',
            minTitle:
                (this.data.mask &&
                    this.data.mask.minTitle.replace(
                        '#global_name#',
                        this.label
                    )) ||
                '',
            maxTitle:
                (this.data.mask &&
                    this.data.mask.maxTitle.replace(
                        '#global_name#',
                        this.label
                    )) ||
                ''
        };
    },
    computed: {
        ...mapState(usePageStore, {
            currentLanguage: store => store.currentLanguage
        }),
        calcMinTitle({ currentLanguage, minTitle }) {
            if (defaultLngCode === currentLanguage) {
                return minTitle;
            }
            return this.$t('common:min');
        },
        calcMaxTitle({ currentLanguage, maxTitle }) {
            if (defaultLngCode === currentLanguage) {
                return maxTitle;
            }
            return this.$t('common:max');
        },
        modelVal: {
            get() {
                return this.value || ',';
            },
            set(val) {
                this.emit(val);
            }
        },
        // Dynamic component
        component() {
            if (this.data && this.data.mask && this.data.mask.mask === 'date') {
                return CalendarSelect;
            } else {
                return InputBox;
            }
        }
    },
    methods: {
        emit(val) {
            this.$emit('change', {
                kee: this.kee,
                value: val,
                type: 'inputBox'
            });
        }
    }
};
</script>
